import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import { notNull } from '~/_shared/utils/typeGuards';
import { usePresentationalColumnsRestrictionsStateSelector } from '~/store/presentationalColumnsRestrictions/presentationalColumnsRestrictions.selectors';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';
import { mapSettingsColumnsFilterClearFilters } from './mapSettingsColumnsFilter.actionCreators';

export const useColumnsFilter = () => {
  const dispatch = useDispatch();
  const isMapPresentational = useIsMapPresentationalSelector();
  const columnsRestrictions = usePresentationalColumnsRestrictionsStateSelector();

  const clearAllColumnsFilters = useCallback(() => {
    let ignoredColumns: SpreadsheetColumnId[] = [];
    if (isMapPresentational) {
      ignoredColumns = Array.from(
        columnsRestrictions.restrictions.entries()
      ).flatMap(([spreadsheetId, columnMap]) =>
        Array.from(columnMap.entries())
          .map(([columnId, restrictions]) =>
            restrictions.filter || restrictions.master
              ? ({ spreadsheetId, columnId })
              : null
          )
          .filter(notNull)
      );
    }

    dispatch(mapSettingsColumnsFilterClearFilters(ignoredColumns));
  }, [dispatch, isMapPresentational, columnsRestrictions]);

  return {
    clearAllColumnsFilters,
  };
};
